import styled from 'styled-components';

const DownSvg = styled.svg`
      fill: ${(props) => props.theme.main.smallTimer};
      opacity: 0;
      transition: .3s;
      width: ${(props) => props.width}px;
      height: ${(props) => props.height}px;
`;
export default DownSvg;
